import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
import {u as utils} from "./utils-cdef6dcd.js";
import {c as capitalize} from "./capitalize-0607751a.js";
import {i as isMuiElement} from "./isMuiElement-5f955b12.js";
import {F as FormControlContext_1, u as useFormControl_1} from "./useFormControl-9e2a3560.js";
import _jsxRuntime from "react/jsx-runtime";
var formControlClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getFormControlUtilityClasses = getFormControlUtilityClasses;
  function getFormControlUtilityClasses(slot) {
    return (0, core.generateUtilityClass)("MuiFormControl", slot);
  }
  const formControlClasses = (0, core.generateUtilityClasses)("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
  var _default = formControlClasses;
  exports.default = _default;
});
var FormControl_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  var _capitalize = interopRequireDefault(capitalize);
  var _isMuiElement = interopRequireDefault(isMuiElement);
  var _FormControlContext = interopRequireDefault(FormControlContext_1);
  const _excluded = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      margin,
      fullWidth
    } = ownerState;
    const slots = {
      root: ["root", margin !== "none" && `margin${(0, _capitalize.default)(margin)}`, fullWidth && "fullWidth"]
    };
    return (0, core.unstable_composeClasses)(slots, formControlClasses_1.getFormControlUtilityClasses, classes);
  };
  const FormControlRoot = (0, _styled.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({
      ownerState
    }, styles) => {
      return (0, _extends2.default)({}, styles.root, styles[`margin${(0, _capitalize.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
  })(({
    ownerState
  }) => (0, _extends2.default)({
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top"
  }, ownerState.margin === "normal" && {
    marginTop: 16,
    marginBottom: 8
  }, ownerState.margin === "dense" && {
    marginTop: 8,
    marginBottom: 4
  }, ownerState.fullWidth && {
    width: "100%"
  }));
  const FormControl2 = /* @__PURE__ */ React$1.forwardRef(function FormControl3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiFormControl"
    });
    const {
      children,
      className,
      color = "primary",
      component = "div",
      disabled = false,
      error = false,
      focused: visuallyFocused,
      fullWidth = false,
      hiddenLabel = false,
      margin = "none",
      required = false,
      size = "medium",
      variant = "outlined"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      color,
      component,
      disabled,
      error,
      fullWidth,
      hiddenLabel,
      margin,
      required,
      size,
      variant
    });
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = React$1.useState(() => {
      let initialAdornedStart = false;
      if (children) {
        React$1.Children.forEach(children, (child) => {
          if (!(0, _isMuiElement.default)(child, ["Input", "Select"])) {
            return;
          }
          const input = (0, _isMuiElement.default)(child, ["Select"]) ? child.props.input : child;
          if (input && (0, utils.isAdornedStart)(input.props)) {
            initialAdornedStart = true;
          }
        });
      }
      return initialAdornedStart;
    });
    const [filled, setFilled] = React$1.useState(() => {
      let initialFilled = false;
      if (children) {
        React$1.Children.forEach(children, (child) => {
          if (!(0, _isMuiElement.default)(child, ["Input", "Select"])) {
            return;
          }
          if ((0, utils.isFilled)(child.props, true)) {
            initialFilled = true;
          }
        });
      }
      return initialFilled;
    });
    const [focusedState, setFocused] = React$1.useState(false);
    if (disabled && focusedState) {
      setFocused(false);
    }
    const focused = visuallyFocused !== void 0 && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const onFilled = React$1.useCallback(() => {
      setFilled(true);
    }, []);
    const onEmpty = React$1.useCallback(() => {
      setFilled(false);
    }, []);
    const childContext = {
      adornedStart,
      setAdornedStart,
      color,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onEmpty,
      onFilled,
      onFocus: () => {
        setFocused(true);
      },
      registerEffect,
      required,
      variant
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
      value: childContext,
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(FormControlRoot, (0, _extends2.default)({
        as: component,
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref
      }, other, {
        children
      }))
    });
  });
  var _default = FormControl2;
  exports.default = _default;
});
var FormControl = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    useFormControl: true,
    formControlClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _FormControl.default;
    }
  });
  Object.defineProperty(exports, "formControlClasses", {
    enumerable: true,
    get: function() {
      return _formControlClasses.default;
    }
  });
  Object.defineProperty(exports, "useFormControl", {
    enumerable: true,
    get: function() {
      return _useFormControl.default;
    }
  });
  var _FormControl = interopRequireDefault(FormControl_1);
  var _useFormControl = interopRequireDefault(useFormControl_1);
  var _formControlClasses = _interopRequireWildcard(formControlClasses_1);
  Object.keys(_formControlClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _formControlClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _formControlClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(FormControl);
export {FormControl as F, __pika_web_default_export_for_treeshaking__ as _};
